<template>
  <div class="vip-product detail-card">
    <div class="detail-card-head">
      <div class="flex flex-1">
        <div class="detail-card-head_title">{{ vipName }}专享权益</div>
        <div v-if="inVip" class="detail-card-head_sub">
          到期时间：{{ vipEndTime }}
        </div>
      </div>
      <div class="detail-card-head-right">
        <a-button
          v-if="inVip"
          style="height: auto; padding: 0"
          class="vip-color"
          type="link"
          @click="openRuleDialog"
        >查看规则</a-button>
        <a-button
          v-else
          style="height: auto"
          class="vip-color"
          type="link"
          @click="openVip"
        >开通会员，解锁权益</a-button>
      </div>
    </div>

    <!--会员保证金-->
    <vip-guarantee-fee v-if="showVipGuarantee" class="m-b-8 m-r-4" />

    <div class="product-list">
      <div
        v-for="item in productCollapseList"
        :key="item.value"
        class="product-list-item"
      >
        <div class="product-list-item_right">
          <img
            class="m-r-8"
            style="width: 18px; height: 18px"
            :src="getProductIcon(item)"
            alt=""
          />
          <a-popover placement="top">
            <template slot="content">
              <p v-for="(pItem, pIndex) in item.popContent" :key="pIndex">
                {{ pItem }}
              </p>
            </template>
            <span class="text-main">{{ item.label }}</span>
          </a-popover>
        </div>
        <div v-if="!item.active">
          <img
            style="width: 15px; height: 16px"
            :src="
              require('@/assets/images/personal-center/vip-home/icon-lock.png')
            "
            alt=""
          />
        </div>
        <div
          v-else-if="item.effectType"
          class="product-list-item_left clickable"
          @click="handleBalanceClick(item)"
        >
          剩余
          <span class="vip-color">{{ getRemain(item.value) }}</span>
          {{ getUnit(item.value) }}
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="collapse-button-wrap">
      <div
        class="collapse-button clickable"
        @click="productCollapse = !productCollapse"
      >
        {{ productCollapse ? '收起权益' : '展开权益' }}
        <i
          :class="productCollapse ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
        ></i>
      </div>
    </div>

    <!-- 增值服务使用规则说明 -->
    <a-modal
      v-model="ruleDialog"
      title="增值服务使用规则说明"
      :mask-closable="false"
      :width="720"
    >
      <div class="rule-body">
        <div class="rule-item">
          <div class="rule-item-title">1.标书预览使用规则</div>
          <div class="rule-item-content">
            标书预览服务只提供预览招标项目的招标文件，不包含附件和澄清文件，也不作为参与项目的依据。
            <span class="text-red">
              每预览一次则扣除一个额度，已预览的招标文件再次查看时不重复扣除额度。
            </span>
          </div>
        </div>
        <div class="rule-item">
          <div class="rule-item-title">2.标讯订阅使用规则</div>
          <div class="rule-item-content">
            标讯订阅使用期限<span
              class="text-red"
            >自购买日开始按照自然日计算</span>，您可前往标前狗PC端或小程序设置关键词等内容，系统将定时为您推送相关商机信息。
          </div>
        </div>
        <div class="rule-item">
          <div class="rule-item-title">3.画像报告使用规则</div>
          <div class="rule-item-content">
            画像报告包含采购单位分析和竞争对手分析，不同等级会员附赠不同的查看额度，<span
              class="text-red"
            >每查看一个画像报告扣除一次额度，已查看过的企业/单位在服务有效期内再次查看时不重复扣除额度</span>。
          </div>
        </div>
        <div class="rule-item">
          <div class="rule-item-title">4.企业关注使用规则</div>
          <div class="rule-item-content">
            不同会员等级附赠对应的企业关注量，超过关注量上限即不可关注更多企业，关注可取消。如规定关注量为100，若已关注100个企业，则无法再关注其它企业，取消已关注的企业后，可关注其它企业。
          </div>
        </div>
        <div class="rule-item">
          <div class="rule-item-title">5.项目关注使用规则</div>
          <div class="rule-item-content">
            不同会员等级附赠对应的项目关注量，超过关注量上限即不可关注更多项目，关注可取消。如规定关注量为100，若已关注100个项目，则无法再关注其它项目，取消已关注的项目后，可关注其它项目。
          </div>
        </div>
        <div class="rule-item">
          <div class="rule-item-title">6.数据导出使用规则</div>
          <div class="rule-item-content">
            项目相关公告数据支持导出，数据导出按照条收费，每条数据包含项目省份、城市、公告标题、正文等11个字段。购买会员会附赠若干导出条数，或购买数据流量包获得导出条数。
          </div>
        </div>
        <div class="rule-item">
          <div class="rule-item-title">7.保证金担保使用规则</div>
          <div class="rule-item-content">
            <p>
              会员保证金担保与会员套餐等级直接关联，不同等级享有不同担保额度。目前套餐中规定的保证金担保仅适用于询比类型的项目，其它项目不支持使用；保证金担保额度可循环使用，使用后在项目结束时恢复额度；
            </p>
            <p>
              会员保证金担保只用于在保证额度以内的项目，超出保证金额度的项目，企业需要全额现金缴纳该项目保证金。
            </p>
          </div>
        </div>
      </div>
      <template v-slot:footer>
        <a-button type="primary" @click="ruleDialog = false">关闭</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
// 组件
import VipGuaranteeFee from '@/components/ValueAddedService/VipHome/VipGuaranteeFee.vue'
// vuex
import { mapGetters, mapState } from 'vuex'
// 字典
import { valueAddedProductCodeDict } from '@/dictionary/value-added-service'
// 工具
import moment from 'moment/moment'

export default {
  name: 'VipProduction',

  components: { VipGuaranteeFee },

  data() {
    return {
      // 权益列表展开
      productCollapse: false,
      // 当前会员的权益信息
      productList: [
        {
          label: '全流程顾问服务',
          value: 'consultant',
          popContent: [
            '全流程顾问服务提供从账号注册、资料变更、发票申领，投标辅助、电子标一对一指导、专属客服等人工服务。'
          ]
        },
        {
          label: '标书预览',
          value: valueAddedProductCodeDict.BID_FILE_PREVIEW.value,
          effectType: valueAddedProductCodeDict.BID_FILE_PREVIEW.effectType,
          popContent: [
            '标书预览可以用于查看采购公告的招标文件内容，助您了解招标文件详情，从而决定是否投标。但不作为已参与项目的依据。'
          ],
          balanceClick: () => {
            this.$router.push({ name: 'BidFilePreview' })
          }
        },
        {
          label: '标讯订阅',
          value: valueAddedProductCodeDict.MARK_SUBSCRIBE.value,
          effectType: valueAddedProductCodeDict.MARK_SUBSCRIBE.effectType,
          popContent: [
            '标讯订阅已在小程序端和PC端上线。通过在标讯订阅设置关键词，以及项目所在地区，信息类别，检索方式等，即可自动获得定制化的标讯，可通过精彩纵横微信公众号接收标讯。'
          ],
          balanceClick: () => {
            const url = process.env.VUE_APP_BIDDOG_URL + '/subscription/list'
            window.open(url, '_target')
          }
        },
        {
          label: '画像报告',
          value: valueAddedProductCodeDict.COMPANY_PORTRAIT.value,
          effectType: valueAddedProductCodeDict.COMPANY_PORTRAIT.effectType,
          popContent: [
            '画像报告包含竞争对手分析和采购单位画像报告查看权益。',
            '竞争对手分析由搜索页和分析报告页组成，主要用于搜索特定供应商企业/单位，并提供入口查看该供应商的分析报告，包含历年中标业绩，参与项目动态，重点客户等内容；',
            '采购单位分析由搜索页和分析报告页组成，主要用于搜索特定采购单位，并提供入口查看该采购单位的分析报告，包含采购单位项目联系人、招标统计概览、高级分析设置、项目动态（历史和最新招标公告记录）、统计图表等内容。'
          ],
          balanceClick: () => {
            this.$router.push({ name: 'PortraitRecord' })
          }
        },
        {
          label: '企业关注',
          value: valueAddedProductCodeDict.FOLLOW_COMPANY.value,
          effectType: valueAddedProductCodeDict.FOLLOW_COMPANY.effectType,
          popContent: [
            '企业/单位关注可为您自动监测您感兴趣的企业/单位的招标/中标动态，关注后，当该企业/单位有中标记录/招标公告更新，您可以关注精彩纵横微信公众号接收系统发送的消息提醒。'
          ],
          balanceClick: () => {
            const url = process.env.VUE_APP_BIDDOG_URL + '/follow/company'
            window.open(url, '_target')
          }
        },
        {
          label: '项目关注',
          value: valueAddedProductCodeDict.FOLLOW_PROJECT.value,
          effectType: valueAddedProductCodeDict.FOLLOW_PROJECT.effectType,
          popContent: [
            '项目关注可为您自动监测您感兴趣的项目，关注后，当该项目有公告更新，您可以关注精彩纵横微信公众号接收系统发送的提醒。'
          ],
          balanceClick: () => {
            const url = process.env.VUE_APP_BIDDOG_URL + '/follow/project'
            window.open(url, '_target')
          }
        },
        {
          label: '数据导出',
          value: valueAddedProductCodeDict.NOTICE_EXPORT.value,
          effectType: valueAddedProductCodeDict.NOTICE_EXPORT.effectType,
          popContent: [
            '您可在数据定制导出页通过设置筛选条件，导出相关标讯数据。数据导出按条收费，每条数据由项目省份、城市、公告标题等11个字段组成。导出后即可在本地查看和分析相关数据。'
          ],
          balanceClick: () => {
            this.$router.push({ name: 'CustomData' })
          }
        },
        {
          label: 'CA抵扣券',
          value: valueAddedProductCodeDict.DIGITAL_CERTIFICATE_VOUCHER.value,
          effectType:
            valueAddedProductCodeDict.DIGITAL_CERTIFICATE_VOUCHER.effectType,
          popContent: [
            '购买会员后即附赠1张CA抵扣券，通过抵扣券，您可在CA开通中心使用抵扣券开通CA。'
          ],
          balanceClick: () => {
            const url = process.env.VUE_APP_LOGIN_JUMP_URL + '/ca/personal/buy'
            window.open(url, '_self')
          }
        },
        {
          label: '电子签章抵扣券',
          value: valueAddedProductCodeDict.ESIGN_VOUCHER.value,
          effectType: valueAddedProductCodeDict.ESIGN_VOUCHER.effectType,
          popContent: [
            '开通会员即可获赠电子签章抵扣券，拥有该券即可在赠送额度范围内免费使用电子签章功能。'
          ],
          balanceClick: () => {
            const url =
              process.env.VUE_APP_LOGIN_JUMP_URL + '/signature/electronic/buy'
            window.open(url, '_self')
          }
        }
      ],

      // 增值服务使用规则说明显示
      ruleDialog: false
    }
  },

  computed: {
    ...mapState('user', ['vipInfo', 'vipBalance']),
    ...mapGetters('user', ['inVip']),

    // 是否显示会员保证金
    showVipGuarantee() {
      const { ADVANCED_VIP, DIAMOND_VIP } = valueAddedProductCodeDict
      return [ADVANCED_VIP, DIAMOND_VIP]
        .map(item => item.value)
        .includes(this.vipInfo.productInfo.productCode)
    },

    // 会员名称
    vipName() {
      return this.vipInfo?.productInfo?.productName || '会员'
    },

    // 会员到期时间
    vipEndTime() {
      const endTime = this.vipInfo?.timeInfo?.endTime
      return endTime ? endTime.split(' ')[0] : '-'
    },

    // 展开或收起下的权益数组
    productCollapseList() {
      const len = this.productList.length
      return this.productList.slice(0, this.productCollapse ? len : 6)
    },

    /**
     * 获取对应产品的余额
     */
    getRemain() {
      return productCode => {
        const balance = this.vipBalance[productCode] || {}
        if (balance.timeInfo) {
          const days = moment(balance.timeInfo.endTime).diff(moment(), 'days')
          return days > 0 ? days : 0
        }
        return balance.remain || 0
      }
    }
  },

  methods: {
    /**
     * 获取对应产品的图标
     */
    getProductIcon(product) {
      if (this.getRemain(product.value) || product.active) {
        return require(`@/assets/images/personal-center/vip-home/icon-${product.value}-active.png`)
      }
      return require(`@/assets/images/personal-center/vip-home/icon-${product.value}.png`)
    },

    /**
     * 获取对应产品的单位
     */
    getUnit(productCode) {
      return valueAddedProductCodeDict.translate(productCode).unit
    },

    /**
     * 处理余额点击事件
     */
    handleBalanceClick(item) {
      if (item.balanceClick) item.balanceClick()
    },

    /**
     * 查看使用规则
     */
    openRuleDialog() {
      this.ruleDialog = true
    },

    /**
     * 查询相应会员等级的套餐余额
     */
    getVipPackage() {
      const {
        MARK_SUBSCRIBE,
        BID_FILE_PREVIEW,
        DIGITAL_CERTIFICATE_VOUCHER,
        COMPANY_PORTRAIT,
        NOTICE_EXPORT,
        ESIGN_VOUCHER
      } = valueAddedProductCodeDict
      const tempProductList = [
        MARK_SUBSCRIBE,
        BID_FILE_PREVIEW,
        DIGITAL_CERTIFICATE_VOUCHER,
        COMPANY_PORTRAIT,
        NOTICE_EXPORT,
        ESIGN_VOUCHER
      ]
      this.$store.dispatch('user/getVipBalance', tempProductList).then(() => {
        const code = this.vipInfo.productInfo?.productCode
        this.productList = this.productList.map(item => {
          // 如果是普通会员，则点亮CA抵扣券
          if (code === valueAddedProductCodeDict.REGULAR_VIP.value) {
            if (
              item.value ===
              valueAddedProductCodeDict.DIGITAL_CERTIFICATE_VOUCHER.value
            ) {
              item.active = true
            }
          }

          // 如果是高级会员或钻石会员，则全部权益点亮
          if (
            code === valueAddedProductCodeDict.DIAMOND_VIP.value ||
            code === valueAddedProductCodeDict.ADVANCED_VIP.value
          ) {
            item.active = true
          }

          // 如果权益余额有值，则点亮
          if (this.getRemain(item.value) > 0) {
            item.active = true
          }

          return item
        })
      })
    },

    /**
     * 开通会员
     */
    openVip() {
      const url = process.env.VUE_APP_PORTAL_URL + '/value-added/vip/buy'
      window.open(url, '_self')
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-card {
  background-color: $white-color;
  border-radius: 4px;
  padding: 20px 24px;

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  .detail-card-head {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .detail-card-head_title {
      font-size: 16px;
      color: $text-color;
      @include text-bold;

      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 16px;
        background: $member-fifth-color;
        margin-right: 6px;
        vertical-align: -12%;
      }
    }

    .detail-card-head_sub {
      font-size: 12px;
      color: $text-second-color;
      margin-left: 8px;
    }
  }
}

.vip-product {
  padding-bottom: 16px;

  .product-list {
    display: flex;
    flex-wrap: wrap;

    .product-list-item {
      width: 33.3%;
      border: 1px solid $info-fourth-color;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 16px;
      margin: 0 -1px -1px 0;

      .product-list-item_right {
        display: flex;
        align-items: center;
      }

      .product-list-item_left {
        font-size: 12px;
        color: $text-second-color;
      }
    }
  }

  .collapse-button-wrap {
    margin-top: 12px;
    text-align: center;
  }
}

.vip-color {
  color: #cb9d46;
}

.rule-body {
  .rule-item {
    &:not(:last-child) {
      margin-bottom: 24px;
    }

    .rule-item-title {
      font-size: 16px;
      @include text-bold;
      color: $text-color;
      margin-bottom: 12px;
    }

    .rule-item-content {
      color: $text-color;
      line-height: 24px;

      .text-red {
        color: $danger-color;
      }
    }
  }
}

.text-main {
  color: $text-color;
}
</style>
